import classNames from 'classnames'

import { getColorWithOpacity } from '../../utils/color'
import { ICON_COLOR } from '../Icon'
import { Tag, TAG_APPEARANCE } from '../Tag'

import {
  STATUS_QA_CONTEXT,
  STATUS_SIZE_24,
  STATUS_TEXT_COLOR,
} from './Status.constants'

import * as styles from './Status.module.css'

function Status({
  backgroundColor,
  className,
  height = STATUS_SIZE_24,
  qaName,
  removeIconColor,
  showTooltip,
  text,
  textClassName,
  textColor,
  textQaName,
  tooltip,
  tooltipPlacement,
  onClick,
  onRemove,
}) {
  return (
    <Tag
      appearance={TAG_APPEARANCE.filled}
      backgroundColor={backgroundColor || getColorWithOpacity(textColor)}
      className={classNames(styles.status, className)}
      height={height}
      qaContext={STATUS_QA_CONTEXT}
      qaName={qaName}
      removeIconColor={removeIconColor || textColor || ICON_COLOR.White}
      text={text}
      textClassName={textClassName}
      textColor={textColor || STATUS_TEXT_COLOR}
      textQaName={textQaName}
      tooltip={showTooltip ? tooltip || text : tooltip}
      tooltipPlacement={tooltipPlacement}
      withTooltip={showTooltip !== false}
      onClick={onClick}
      onRemove={onRemove}
    />
  )
}

export default Status
